/**
 * Removes any non-numeric characters from a given string.
 * @param {string} input The string to format.
 * @returns {string} The string only containing numeric characters.
 */
export function stripNonNumericChars(input: string): string {
  return input.replace(/[^\d]/g, '');
}
